// extracted by mini-css-extract-plugin
var _1 = "RequestBoardColumn-moduleRequestBoardColumn__niOQ7";
var _2 = "RequestBoardColumn-moduleheader__AJumn";
var _3 = "RequestBoardColumn-moduleskeletonCount__lC13z Skeleton-moduleSkeleton__Mlrfv";
var _4 = "RequestBoardColumn-moduletrack__krqgq";
var _5 = "RequestBoardColumn-modulezeroCount__tGYl7 Counter-modulecounter__yXwqU Counter-moduletable__yR0uS";
export { _1 as "RequestBoardColumn", _2 as "header", _3 as "skeletonCount", _4 as "track", _5 as "zeroCount" }
